// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3Jbb2","gfeWrapper":"CalendarEvent_gfeWrapper__J67Og"};